import { createSelector } from '@ngrx/store';
import { FilteredClientAccount } from '@shared/models';
import { ISelectedClientAccountsState } from '@store/reducers/selected-client-accounts/selected-client-accounts.reducer';
import { selectVCDSettlementFundsToggle } from '@store/selectors/feature/feature.selectors';
import { selectAcceptedDAOffer } from '@store/selectors/open-choice/open-choice.selectors';

import { selectEligibleIndividualAccounts } from '../../client-accounts/client-accounts.selectors';
import { selectedClientAccountsState } from '../../selected-client-accounts/selected-client-accounts.selectors';
import { nullState } from '../common/router.selectors';
import {
  getMinorContactInfoNextPage,
  getMinorEmploymentNextPage,
  getMinorIncomeNetWorthNextPage,
  getMinorInvestObjNextPage,
  getMinorPersonalInfoNextPage,
  getMinorReviewNextPage,
  getMinorSettlementFundNextPage,
  getMinorTermsNextPage,
  getMinorTransferFromNextPage,
  getMinorTransferToNextPage,
  getOpenChoiceEnrollPage,
} from './minor-transfer-router.helpers';

//minor selectors
export const selectMinorTransferFromNextPage = createSelector(
  selectEligibleIndividualAccounts(),
  (individualAccounts: FilteredClientAccount) => getMinorTransferFromNextPage(individualAccounts),
);
export const selectMinorTransferToNextPage = createSelector(
  selectedClientAccountsState,
  (selectedAccounts: ISelectedClientAccountsState) => getMinorTransferToNextPage(selectedAccounts),
);
export const selectMinorPersonalInfoNextPage = createSelector(nullState, () =>
  getMinorPersonalInfoNextPage(),
);
export const selectMinorContactInfoNextPage = createSelector(
  selectVCDSettlementFundsToggle,
  (settlementFundToggle) => getMinorContactInfoNextPage(settlementFundToggle),
);
export const selectMinorSettlementFundNextPage = createSelector(nullState, () =>
  getMinorSettlementFundNextPage(),
);
export const selectMinorEmploymentNextPage = createSelector(nullState, () =>
  getMinorEmploymentNextPage(),
);
export const selectMinorInvestObjNextPage = createSelector(nullState, () =>
  getMinorInvestObjNextPage(),
);
export const selectMinorIncomeNetWorthNextPage = createSelector(nullState, () =>
  getMinorIncomeNetWorthNextPage(),
);

export const selectMinorReviewNextPage = createSelector(
  selectedClientAccountsState,
  selectAcceptedDAOffer,
  (selectedAccounts: ISelectedClientAccountsState, acceptedDaOffer) => {
    if (acceptedDaOffer) {
      return getOpenChoiceEnrollPage();
    }
    return getMinorReviewNextPage(selectedAccounts);
  },
);
export const selectMinorTermsNextPage = createSelector(nullState, () => getMinorTermsNextPage());
